import { makeStyles } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useChallengeItemStyles = makeStyles({
  container: {
    padding: customTokens.spacingVerticalM,
  },
  containerWrap: {
    display: 'flex',
  },
  cardContent: {
    flexGrow: 1,
    paddingTop: customTokens.spacingVerticalNone,
    paddingLeft: customTokens.spacingVerticalM,
    paddingRight: customTokens.spacingVerticalM,
    paddingBottom: customTokens.spacingVerticalSNudge,
  },
  title: {
    fontSize: customTokens.fontSizeBase450,
    fontWeight: customTokens.fontWeightBold,
    lineHeight: customTokens.lineHeightBase450,
  },
  description: {
    fontSize: customTokens.fontSizeBase300,
    lineHeight: customTokens.lineHeightBase300,
  },
  cardActions: { marginTop: customTokens.spacingVerticalL, display: 'flex', justifyContent: 'space-between' },
  cardActionContainer: { marginLeft: 'auto' },
  link: {
    fontSize: customTokens.fontSizeBase200,
    lineHeight: customTokens.lineHeightBase200,
    paddingTop: customTokens.spacingVerticalSNudge,
    paddingBottom: customTokens.spacingVerticalSNudge,
  },

});
